export const login = (data) => {
    return data.data
}
export const coachRegisterApiGet = (data) => {
    return data.data
}
export const getTeamListApiGet = (data) => {
    return data.data
}
export const forgotPasswordApiGet = (data) => {
    return data.data
}
export const imageUploadApiPost = (data) => {
    return data.data
}
export const getCountyApiGet = (data) => {
    return data.data
}


